module.exports = __webpack_public_path__ + "static/media/OOCL.df79d765.svg";